import { render } from "./final-page.vue?vue&type=template&id=1319a0ad&scoped=true"
import script from "./final-page.vue?vue&type=script&lang=js"
export * from "./final-page.vue?vue&type=script&lang=js"

import "./final-page.vue?vue&type=style&index=0&id=1319a0ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1319a0ad"]])

export default __exports__